export default [
  {
    text: "대시보드",
    path: "/HomeSTOM",
    icon: "fa fa-home text-primary",
  },
  {
    text: "견적서",
    path: "/Supplier/Quotation4STOM/",
    icon: "fa fa-level-up text-primary",
  },
];
